var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.likebox.enabled)?_c('div',{staticClass:"Mw-PostLogin-thankyou-like-box"},[(_vm.showLikeBox)?_c('div',{staticClass:"fb-page",attrs:{"id":"fb-page","data-href":_vm.url,"data-hide-cover":"false","data-show-facepile":"true","data-show-posts":"false"}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }